module.exports = __webpack_public_path__ + "static/media/pla_clear_green_stripes_straw1.5a6b0169.png";